/**
	* @license
	* Copyright Akveo. All Rights Reserved.
	* Licensed under the MIT License. See License.txt in the project root for license information.
	*/
import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { SeoService } from "./@core/utils/seo.service";
import { TranslateService } from "@ngx-translate/core";
import { LocaleService } from "./services/locale.service";
import { MockService } from "./services/mock.service";
import { Subscription } from "rxjs";

@Component({
	selector: "ngx-app",
	template: "<router-outlet></router-outlet>",
	styleUrls: ["app.component.scss"]
})
export class AppComponent implements OnInit {
	subscriptions: Subscription = new Subscription();

	constructor(
		private analytics: AnalyticsService,
		private seoService: SeoService,
		private localeService: LocaleService,
		private translateService: TranslateService,
		private service: MockService,
	) {
		const lang = this.translateService.getBrowserLang();
		this.localeService.initLocale(lang);
	}

	ngOnInit(): void {
		this.analytics.trackPageViews();
		this.seoService.trackCanonicalChanges();
	}
}
